import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../services/api';
import { TIER_LABELS } from '../../utils/tiers';
import { formatNumber } from '../admin/shared';
import BillingMonthsTable from './BillingMonthsTable';

function BillingTab() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['billing', apiService.getInstanceInfo()?.instanceKey],
    queryFn: apiService.getBilling,
    retry: false,
  });

  if (isLoading) return <div role="status" className="text-sm text-secondary p-6">Loading billing...</div>;
  if (error || !data) {
    return <div role="alert" className="mb-4 bg-red-600/20 text-red-400 px-4 py-2 rounded text-sm">Failed to load billing.</div>;
  }

  return (
    <div className="space-y-6">
      <div className="bg-widget-bg rounded-lg border border-gray-700 p-6">
        <dl className="flex flex-wrap gap-x-10 gap-y-3">
          <div className="flex gap-2">
            <dt className="text-secondary">License tier</dt>
            <dd className="text-heading">{TIER_LABELS[data.tier]}</dd>
          </div>
          <div className="flex gap-2">
            <dt className="text-secondary">Credit balance</dt>
            <dd className="text-heading">{formatNumber(data.credits.balance)} tokens</dd>
          </div>
        </dl>
      </div>
      <BillingMonthsTable months={data.months} />
    </div>
  );
}

export default BillingTab;
